export const LOADING_TIMEOUT = 1000;
